// extracted by mini-css-extract-plugin
export var footer = "_in-0";
export var inherit = "_in-1";
export var input = "_in-2";
export var modalContent = "_in-3";
export var quillEditor = "_in-4";
export var subtitle = "_in-5";